const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
require('moment-recur');
/**
 * Defines the add Images component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addDateSet', [
  'Application', 'Authorization',
  'Workshops',
  'WorkshopInstances',
  'MultiSessionWorkshops',
  'ZoomIntegrate',
  'MicrosoftTeams',
  '$q',
  '$translate',
  'Meets',
  function (Application, Authorization, Workshops, WorkshopInstances, MultiSessionWorkshops, ZoomIntegrate, MicrosoftTeams, $q, $translate, Meets) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        hideShow: '=',
        datesAdded: '&',
        workshop: '=?',
        instance: '=?',
        defaultInstance: '=?',
        editing: '@',
        instructions: '=?',
        onChange: '&?',
        state: '=?',
      },
      template: require('../../../templates/directives/cms/add-date-set.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.user = Authorization.getAuthToken().user;
          self.mediumOpts = {
            targetBlank: true,
            toolbar: {
              buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist'],
            },
          };

          $translate([
            "errors.workshop.instance.create.ZOOM_API_CREATE_ERROR",
            "errors.workshop.instance.update.ZOOM_API_CREATE_ERROR",
            "errors.workshop.instance.create.MEETS_API_CREATE_ERROR",
            "errors.workshop.instance.update.MEETS_API_CREATE_ERROR"
          ]).then(function(translations){
            self.translations = translations;
          });

          self.dateFormat = Application.dateFormatting.getWorkshopPickerFormat();
          self.momentFormat = Application.dateFormatting.getMomentFormat();
          self.universalFormat = Application.dateFormatting.getUniversalDateFormat();
          self.isSession = Application.navigation.getPath().includes('multi-session-workshops');
          if (self.isSession) {
            var multiSessionId = Application.navigation.getRouteParameters().id;
          }

          self.dateFromString = function (date, time, tz) {
            const timezone = tz !== undefined ? tz : self.config.instanceBody.viewing_timezone;
            const d = moment.tz(date, self.momentFormat, timezone);
            if (time !== undefined) {
              const hours = time.getHours();
              const minutes = time.getMinutes();
              return d.hour(hours).minute(minutes);
            } else {
              return d;
            }
          }

          self.languageAsVirtual = false;
          if (Application.LAYOUT === 'lyft') {
            self.languageAsVirtual = true;
          }

          self.options = {
            timezones: [],
            endDays: [
              { value: '0', name: 'Same Day' },
              { value: '1', name: 'Next Day' },
              { value: '2', name: '2nd Day' },
              { value: '3', name: '3rd Day' },
              { value: '4', name: '4th Day' },
              { value: '5', name: '5th Day' },
              { value: '6', name: '6th Day' },
            ],
            days: [ //TODO: Update to use Locale-based names
              { value: 'sunday', name: 'Sunday' },
              { value: 'monday', name: 'Monday' },
              { value: 'tuesday', name: 'Tuesday' },
              { value: 'wednesday', name: 'Wednesday' },
              { value: 'thursday', name: 'Thursday' },
              { value: 'friday', name: 'Friday' },
              { value: 'saturday', name: 'Saturday' },
            ],
            numberedDays: [
              { value: 1, name: '1st' },
              { value: 2, name: '2nd' },
              { value: 3, name: '3rd' },
              { value: 4, name: '4th' },
              { value: 5, name: '5th' },
              { value: 6, name: '6th' },
              { value: 7, name: '7th' },
              { value: 8, name: '8th' },
              { value: 9, name: '9th' },
              { value: 10, name: '10th' },
              { value: 11, name: '11th' },
              { value: 12, name: '12th' },
              { value: 13, name: '13th' },
              { value: 14, name: '14th' },
              { value: 15, name: '15th' },
              { value: 16, name: '16th' },
              { value: 17, name: '17th' },
              { value: 18, name: '18th' },
              { value: 19, name: '19th' },
              { value: 20, name: '20th' },
              { value: 21, name: '21st' },
              { value: 22, name: '22nd' },
              { value: 23, name: '23rd' },
              { value: 24, name: '24th' },
              { value: 25, name: '25th' },
              { value: 26, name: '26th' },
              { value: 27, name: '27th' },
              { value: 28, name: '28th' },
              { value: 29, name: '29th' },
              { value: 30, name: '30th' },
              { value: 31, name: '31st' },
            ],
            repeatType: [
              { value: 'daily', name: 'Daily' },
              { value: 'weekly', name: 'Weekly' },
              { value: 'monthly', name: 'Monthly' },
            ],
            dayType: [
              { value: '0', name: 'First' },
              { value: '1', name: 'Second' },
              { value: '2', name: 'Third' },
              { value: '3', name: 'Fourth' },
            ],
          };
          function setTimezones() {
            self.options.timezones = moment.tz.names().map(function (name) {
              var replaced = name.replace(/\//g, ' / ');
              replaced = replaced.replace(/_/g, ' ');
              return { value: name, name: replaced };
            });
          }
          setTimezones();

          var guessedTz = moment.tz.guess();
          self.config = {
            loading: true,
            saving: false,
            zoomAllowed: false,
            zoomUserAllowed: false,
            allowWebinar: false,
            microsoftTeamsAllowed: false,
            microsoftTeamsIntegrated: false,
            activeMicrosoftTeams: false,
            microsoftTeamsMeetingLink: '',
            meetsAllowed: Application.features.flags().enable_google_meets,
            meetsUserEnabled: self.user && self.user.google_meets && self.user.google_meets.access_token,
            aiEnabled: Application.features.flags().enable_generative_ai,
            displayAutoAttendanceOption: Application.features.flags().enable_auto_workshop_attendance, // online will also need to be selected
            repeatType: 'daily',
            dateType: 'single',
            single: {
              startTime: new Date(moment().tz(guessedTz).add(1, 'months').set('hour', 14).minutes(0).seconds(0).milliseconds(0).valueOf()), 
              endTime: new Date(moment().tz(guessedTz).add(1, 'months').set('hour', 17).minutes(0).seconds(0).milliseconds(0).valueOf()),
              startDate: moment().tz(guessedTz).add(1, 'months').hours(12).minutes(0).seconds(0).milliseconds(0).format(self.momentFormat),
              endDate: moment().tz(guessedTz).add(1, 'months').hours(12).minutes(0).seconds(0).milliseconds(0).format(self.momentFormat),
            },
            multiple: {
              startTime: new Date(moment().tz(guessedTz).add(1, 'months').set('hour', 14).minutes(0).seconds(0).milliseconds(0).valueOf()),
              endTime: new Date(moment().tz(guessedTz).add(1, 'months').set('hour', 17).minutes(0).seconds(0).milliseconds(0).valueOf()),
              duration: '0',
              startDate: moment().tz(guessedTz).add(1, 'months').hours(5).minutes(0).seconds(0).milliseconds(0).format(self.momentFormat),
              endDate: moment().tz(guessedTz).add(2, 'months').hours(5).minutes(0).seconds(0).milliseconds(0).format(self.momentFormat),
              startDisplay: '',
              endDisplay: '',
              durationDisplay: '',
              intervals: [],
            },
            switchType: function (type) {
              watchHold = true;
              this.dateType = type;
               
              var start = self.dateFromString(self.config[type].startDate, self.config[type].startTime);
              var end = self.dateFromString(self.config[type].endDate, self.config[type].endTime);
              self.init.handleTz(start, end);

              watchHold = false;
              watchTrigger(true);
              
            },
            resetInstanceBody: function () {
              this.instanceBody = {
                viewing_timezone: guessedTz,
                seats: 20,
                allow_waitlist: false,
                waitlist_seats: 5,
                host: {
                  name: '',
                  image: '',
                  bio: '',
                },
                online: false,
                location: {
                  venue: '',
                  address_1: '',
                  address_2: '',
                  city_state: '',
                  country: '',
                },
                online_location: '',
                online_location_label: '',
                site: '',
                user: self.user._id,
                google_calendar_entity: false,
                google_calendar_see_attendees: false,
                remove_on_google_decline: false,
                createZoom: false,
                createMeet: false,
                zoomType: 'meeting',
                zoom_settings: {},
                createMicrosoftTeamsMeeting: false,
                allow_auto_attendance: false,
              };

              this.originalLink = '';
              this.originalZoomLink = '';
            },
            instanceBody: {},
            addImage: function (link) {
              this.instanceBody.host.image = link;
            },
            confirmRequirements: function () {
              var missing = [];
              if (!self.config.instanceBody.host.name) {
                missing.push('Facilitator Name');
              }
              if (!self.config.instanceBody.host.bio) {
                missing.push('Facilitator Bio');
              }
              if (!self.config.instanceBody.seats) {
                missing.push('Maximum Participants');
              }
              if (self.config.instanceBody.online) {
                if (!self.config.instanceBody.online_location && (!self.config.instanceBody.createZoom && !self.config.instanceBody.createMeet)) {
                  missing.push('Online Workshop URL');
                }
                if (!self.config.instanceBody.online_location_label) {
                  missing.push('Online Workshop URL Title');
                }
              }
              if (!self.config.instanceBody.online) {
                if (!self.config.instanceBody.location.venue) {
                  missing.push('Venue');
                }
              }
              if (self.config.dateType === 'multiple') {
                if (self.config.repeatType === 'weekly' && (!self.weeklyOptions.repeatDays || !self.weeklyOptions.repeatDays.length)) {
                  missing.push('Days of the Week');
                }
                if (self.config.repeatType === 'monthly') {
                  if (self.monthlyOptions.type === 'single' && !self.monthlyOptions.single) {
                    missing.push('Recurrence Interval');
                  }
                  if (self.monthlyOptions.type === 'repeat' && (!self.monthlyOptions.repeatDays || !self.monthlyOptions.repeatDays.length)) {
                    missing.push('Recurrence Interval');
                  }
                }
              }
              if (missing.length) {
                var message = 'The following fields are required: ';
                missing.forEach(function (item, index) {
                  message += item;
                  if (index === missing.length - 1) {
                    message += '.';
                    return;
                  }
                  message += ', ';
                });
                Application.messaging.addMessage({ type: 'error', duration: 6, text: message });
                return false;
              }
              return true;
            },
            createDates: function () {
              if (!self.config.confirmRequirements()) {
                return;
              }


              this.saving = true;

              var dateType = self.config.dateType;
              var startDate = self.dateFromString(self.config[dateType].startDate, self.config[dateType].startTime);
              var endDate = self.dateFromString(self.config[dateType].endDate, self.config[dateType].endTime);

              // warn the user if they are trying to create an invalid date
              if (startDate.isAfter(endDate, 'minute')) {
                Application.messaging.addMessage({ type: 'error', duration: 5, text: 'Start time can not be after end time' });
                self.config.saving = false;
                return;
              }

              if (dateType === 'multiple') {
                if (this.instanceBody.online && this.instanceBody.createMeet) {
                  if (self.config.multiple.intervals.length > 4) {
                    Application.messaging.addMessage({type: 'error', duration: 7, text: 'Too many dates. Due to API restrictions with Google Meets, a maximum of 4 dates can be created at one time.'});
                    this.saving = false;
                    return;
                  }
                }
                const intervalFormat = moment.localeData().longDateFormat('L');
                moment.localeData().longDateFormat('L')
                this.instanceBody.dateInfo = {
                  dates: self.config.multiple.intervals.map(intervalDate => moment(intervalDate, intervalFormat).format(self.universalFormat)),
                  startTime: startDate.valueOf(),
                  endTime: endDate.valueOf(),
                  duration: self.config.multiple.duration, 
                };
              }

              if (self.config.dateType === 'single') {
              
                this.instanceBody.dateInfo = {
                  dates: [startDate.format(self.universalFormat)],
                  startTime: startDate.valueOf(),
                  endTime: endDate.valueOf(),
                  duration: self.getDateDiff(startDate,endDate),
                };
              }

              if (!this.instanceBody.online || !this.instanceBody.createZoom) {
                delete this.instanceBody.createZoom;
                delete this.instanceBody.zoomType;
                this.instanceBody.zoom_settings = {};
              }

              if (this.instanceBody.online && this.instanceBody.createZoom && this.instanceBody.zoom_settings) {
                this.instanceBody.zoom_settings.alternative_hosts = self.zoomHosts.stringValue || '';
              }

              if (!this.instanceBody.online || !this.instanceBody.createMeet) {
                delete this.instanceBody.createMeet;
              }

              this.createWorkshop()
                .then(function (workshop) {
                  if (workshop && workshop.id) {
                    $scope.workshop._id = workshop.id;
                  }
                  if (workshop && workshop._id) {
                    $scope.workshop._id = workshop._id;
                  }
                  self.config.instanceBody.workshop = $scope.workshop._id;
                  if (self.config.activeMicrosoftTeams) {
                    self.config.instanceBody.createMicrosoftTeamsMeeting = true;
                  }
                  return self.config.createInstances(self.config.instanceBody);
                })
                .then(function (response) {
                  $scope.datesAdded();
                  self.config.saving = false;
                  Application.messaging.renderApiResponseErrorCodes(response, {
                    ZOOM_API_CREATE_ERROR: self.translations["errors.workshop.instance.create.ZOOM_API_CREATE_ERROR"],
                    MEETS_API_CREATE_ERROR: self.translations["errors.workshop.instance.create.MEETS_API_CREATE_ERROR"],
                  });
                })
                .catch(function (error) {
                  console.error('error in instance creation: ', error);
                  if (error.data && error.data.message) {
                    Application.messaging.addMessage({ type: 'error', duration: 5, text: error.data.message });
                  } else {
                    Application.messaging.addMessage({ type: 'error', duration: 5, text: 'There was an error in creating instances.' });
                  }
                  self.config.saving = false;
                });
            },
            createInstances: function (body) {
              return WorkshopInstances.createOccurrence(body).$promise;
            },
            createWorkshop: function () {
              if ($scope.workshop && $scope.workshop._id) {
                var deferred = $q.defer();
                deferred.resolve('existed');
                return deferred.promise;
              }
              if (self.user.is_collaborator) {
                $scope.workshop.approval_required = true;
                $scope.workshop.approved = false;
              }
              if (self.isSession) {
                return MultiSessionWorkshops.createSession({ subresource: multiSessionId }, $scope.workshop).$promise;
              }
              return Workshops.create($scope.workshop).$promise;
            },
            resetInstance: function (id) {
              self.config.saving = true;
              self.active_zoom = false;
              self.config.activeMicrosoftTeams = false;
              return WorkshopInstances.get({ subresource: id, fields: self.config.transferEditItems.join(',') })
                .$promise.then(function (instance) {
                  if ($scope.editing && instance.online && instance.zoom_meeting_id) {
                    self.active_zoom = true;
                  }
                  if ($scope.editing && instance.online && instance.microsoft_teams_meeting_id) {
                    self.config.microsoftTeamsMeetingLink = instance.online_location;
                    self.config.activeMicrosoftTeams = true;
                  }
                  self.init.reset(instance);
                  self.config.saving = false;
                })
                .catch(function (error) {
                  // handle error
                  console.error('error in getting workshop instance: ', error);
                  self.config.saving = false;
                });
            },
            transferEditItems: [
              '_id',
              'user',
              'start_date',
              'end_date',
              'viewing_timezone',
              'seats',
              'allow_waitlist',
              'waitlist_seats',
              'host',
              'location',
              'online_location',
              'online_location_label',
              'online',
              'site',
              'google_calendar_entity',
              'google_calendar_see_attendees',
              'remove_on_google_decline',
              'zoom_meeting_id',
              'zoom_settings',
              'host_reminder',
              'microsoft_teams_meeting_id',
              'microsoft_teams_meeting_settings',
              'google_meets',
              'allow_auto_attendance'
            ],
            transferDefaultItems: [
              'start_date',
              'end_date',
              'viewing_timezone',
              'seats',
              'allow_waitlist',
              'waitlist_seats',
              'host',
              'location',
              'online_location_label',
              'online',
              'site',
              'google_calendar_entity',
              'google_calendar_see_attendees',
              'remove_on_google_decline',
              'host_reminder',
              'microsoft_teams_meeting_id',
              'microsoft_teams_meeting_settings',
            ],
            originalLink: '',
            originalZoomLink: '',
            useZoom: function () {
              if (!this.instanceBody.createZoom) {
                this.originalLink = this.instanceBody.online_location;
                this.instanceBody.online_location = '';
                if (this.originalZoomLink) {
                  this.instanceBody.online_location = this.originalZoomLink;
                }
                if (!this.instanceBody.online_location_label) {
                  this.instanceBody.online_location_label = 'Join Zoom Meeting';
                }
                this.instanceBody.createZoom = true;
                return;
              }

              this.instanceBody.createZoom = false;
              if (this.instanceBody.online_location) {
                this.originalZoomLink = this.instanceBody.online_location;
              }
              this.instanceBody.online_location = '';
              if (this.originalLink) {
                this.instanceBody.online_location = this.originalLink;
                this.originalLink = '';
              }
            },
            allowZoomCreate: function () {
              if (!self.config.zoomAllowed) {
                return false;
              }
              if (self.config.zoomUserAllowed) {
                return true;
              }
              if (self.config.instanceBody.zoom_meeting_id) {
                return true;
              }
              return false;
            },
            zoomTypeDisabled: function (type) {
              if (type === 'webinar' && !self.config.allowWebinar) {
                return true;
              }
              if (!$scope.editing || !self.editing.original) {
                return false;
              }
              return $scope.editing && self.editing.original.online && self.editing.original.zoom_meeting_id;
            },
            zoomType: function (type) {
              if (this.zoomTypeDisabled(type)) {
                return;
              }
              self.config.instanceBody.zoomType = type;
            },
            toggleMicrosoftTeams: () => {
              if (!self.config.activeMicrosoftTeams) {
                self.config.instanceBody.online_location = self.config.microsoftTeamsMeetingLink ? self.config.microsoftTeamsMeetingLink : 'Microsoft Teams Meeting';
                self.config.activeMicrosoftTeams = true;
              } else {
                self.config.instanceBody.online_location = '';
                self.config.activeMicrosoftTeams = false;
              }
            },
          };

          self.zoomHosts = {
            loading: false,
            editingValue: '',
            stringValue: '',
            list: [],
            verified: {},
            toList: function (item) {
              self.zoomHosts.list = item.split(';');
            },
            toString: function (list) {
              self.zoomHosts.stringValue = list.join(';');
            },
            parseEdit: function (item) {
              self.zoomHosts.stringValue = item;
              self.zoomHosts.toList(item);
              self.zoomHosts.list.forEach(function (email) {
                self.zoomHosts[email] = true;
              });
            },
            onAdd: function () {
              // verify addition, add to verified, and set string
              if (self.zoomHosts.verified[self.zoomHosts.editingValue]) {
                self.zoomHosts.list.push(self.zoomHosts.editingValue);
                self.zoomHosts.toString(self.zoomHosts.list);
                self.zoomHosts.editingValue = '';
                return;
              }

              self.zoomHosts.loading = true;
              ZoomIntegrate.checkZoomUser({ option: window.encodeURIComponent(self.zoomHosts.editingValue) }).$promise.then(function (results) {
                self.zoomHosts.loading = false;

                if (results.user_exists) {
                  self.zoomHosts.verified[self.zoomHosts.editingValue] = true;
                  self.zoomHosts.list.push(self.zoomHosts.editingValue);
                  self.zoomHosts.toString(self.zoomHosts.list);
                  self.zoomHosts.editingValue = '';
                  $scope.$apply();
                  return;
                }

                Application.messaging.addMessage({ type: 'error', duration: 7, text: 'This user is not eligible to be an alternative host.' });
              });
            },
            onRemove: function (index) {
              self.zoomHosts.list.splice(index, 1);
              self.zoomHosts.toString(self.zoomHosts.list);
            },
          };

          self.removeMeetLink = function() {
            self.madeWithGoogle = false;
            self.config.instanceBody.online_location = '';
          };

          self.config.resetInstanceBody();

          self.weeklyOptions = {
            repeatDays: [],
            dayChange: function (day) {
              var index = this.repeatDays.indexOf(day);
              if (index === -1) {
                this.repeatDays.push(day);
                self.timeConversions.setInstances();
                return;
              }
              this.repeatDays.splice(index, 1);
              self.timeConversions.setInstances();
            },
          };

          self.monthlyOptions = {
            type: 'single',
            single: '',
            dayType: '0',
            repeatDays: [],
            dayChange: function (day) {
              var index = this.repeatDays.indexOf(day);
              if (index === -1) {
                this.repeatDays.push(day);
                self.timeConversions.setInstances();
                return;
              }
              this.repeatDays.splice(index, 1);
              self.timeConversions.setInstances();
            },
          };

          self.getDateDiff = (start, end) => {
            if (!moment.isMoment(start) || !moment.isMoment(end)) {
              return moment(end).endOf('day').diff(moment(start).startOf('day'), 'days');    
            } else {
              //We have to call clone because endOf and startOf mutate the moment object
              return end.clone().endOf('day').diff(start.clone().startOf('day'), 'days');
            }
          }

          self.timeConversions = {

            // Since we're using ng-model for the date/time input on this page we HAVE to use
            // Javascript Date which forces the date to the local timezone. Given how we utilize moment
            // heavily to have better control of dates and timezones we have to force the date object
            // to persist the time and date. moment().toDate() does not work as you would expect and always
            // manipulates the date to the local timezone.
            dateFromMoment: (momentDate) => {
                var m = momentDate;
                return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0, 0);
            },
            singleCheckTime: function (span) {
              var start = self.dateFromString(self.config.single.startDate, self.config.single.startTime)
              var end = self.dateFromString(self.config.single.endDate, self.config.single.endTime)
              
              if (start.isAfter(end, 'day')) {
              
                if (span === 'start') {
                  self.config.single.endDate = start.format(self.momentFormat);
                  end = self.dateFromString(self.config.single.endDate, self.config.single.endTime);
                }

                if (span === 'end') {
                  self.config.single.startDate = end.format(self.momentFormat);
                  start = self.dateFromString(self.config.single.startDate, self.config.single.startTime);
                }
              }

              if (start.isSameOrAfter(end, 'minute')) {
              
                if (span === 'start') {
                  self.config.single.endTime = self.timeConversions.dateFromMoment(start.clone().add(1, 'hour'));
                }

                if (span === 'end') {
                  self.config.single.startTime = self.timeConversions.dateFromMoment(end.clone().subtract(1, 'hour'));
                }
              }
            },
            multipleCheckTime: function (span) {
              if (span) {
                var start = self.dateFromString(self.config.multiple.startDate, self.config.multiple.startTime);
                var end = self.dateFromString(self.config.multiple.endDate, self.config.multiple.endTime);
                if (end.isAfter(start, 'day') > 0) {
                  return;
                }
                if (span === 'start') {
                  self.config.multiple.endDate = start.clone().add(1, 'day').format(self.momentFormat);
                  return;
                }
                self.config.multiple.startDate = end.clone().subtract(1, 'days').format(self.momentFormat);
              }
              if (self.config.multiple.duration !== '0') {
                return;
              }

              if (start > end) {
                self.config.multiple.duration = '1';
              }
            },
            blurValidate: function (singleOrMultiple, startOrEndDate) {

              var dateIsValid = self.timeConversions.validateDate(singleOrMultiple, startOrEndDate);

              if (!dateIsValid) {
                self.timeConversions.formatDate(singleOrMultiple, startOrEndDate, true);
                return;
              }

              if (singleOrMultiple === 'multiple' && startOrEndDate === 'endDate') {
                watchHold = true;
                var firstDate = self.dateFromString(self.config.multiple.startDate, self.config.multiple.startTime);
                var lastDate = self.dateFromString(self.config.multiple.endDate, self.config.multiple.endTime);
                if (firstDate.isAfter(lastDate, 'minute')) {
                  self.config.multiple.startDate = lastDate.clone().format(self.momentFormat); 
                  firstDate = self.dateFromString(self.config.multiple.startDate, self.config.multiple.startTime);
                }
                if (lastDate.diff(firstDate, 'years') > 0) {
                  self.config.multiple.endDate = firstDate.add('years', 1).format(self.momentFormat);
                }
                watchHold = false;
              }

              watchTrigger(true, startOrEndDate.slice(0, -4));
            },
            /*
              dateRegex matches dates with 1-2 M and D digits, and 2 or 4 Y digits,
              separated by "/", "-", or "." and accounts for USA/AUS date formats
              Examples:
              M/D/YY
              DD-MM-YYYY
              M.DD.YY
             */
            validateDate: function (singleOrMultiple, startOrEndDate) {
              var testDate = self.config[singleOrMultiple][startOrEndDate];
              if (testDate === 'Invalid date') {
                return false;
              }
              var dateRegex = /^\d{1,2}[/.-]\d{1,2}[/.-](?:\d{4}|\d{2})$/;
              var isValid = dateRegex.test(testDate);
              // if (!isValid) {
              //   self.timeConversions.formatDate(singleOrMultiple, startOrEndDate, true);
              // } else {
              //   self.timeConversions.formatDate(singleOrMultiple, startOrEndDate);
              // }
              return isValid;
            },
            formatDate: function (singleOrMultiple, startOrEndDate, isInvalid) {
              if (isInvalid) {
                self.config[singleOrMultiple][startOrEndDate] = 'Invalid date';
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Invalid date.  Please enter a valid date using "/", "-", or "."' });
                return;
              }
              var time = startOrEndDate === 'endDate' ? self.config[singleOrMultiple].endTime : self.config[singleOrMultiple].startTime;
              var fullDate = self.dateFromString(self.config[singleOrMultiple][startOrEndDate], self.config[singleOrMultiple][time]);
              self.config[singleOrMultiple][startOrEndDate] = fullDate.format(self.momentFormat);

              // if date is invalid according to momentjs, e.g. entered in wrong format
              if (self.config[singleOrMultiple][startOrEndDate] === 'Invalid date') {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Invalid date.  Please enter a valid date using "/", "-", or "."' });
              }
            },
            setIntervals: function (intervals) {
              if (!intervals || !intervals.length) {
                return;
              }
              if (intervals.length > 100) {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'This schedule would create more than the maximum of 100 dates.' });
                return;
              }
              self.config.multiple.intervals = intervals;
            },
            // limits possible total number of intervals set in setIntervals
            preliminaryRecurrenceCheck: function (amount) {
              if (amount > 100) {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'This schedule would create more than the maximum of 100 dates.' });
                return false;
              }
              return true;
            },
            setInstances: function () {
              var startDate = self.config.multiple.startDate;
              var endDate = self.config.multiple.endDate;  
              if (self.config.dateType === 'single') {
                return;
              }
              self.config.multiple.intervals = [];
              self.config.multiple.durationDisplay = '';
              if (!startDate || !self.config.multiple.startTime) {
                return;
              }

              var fullStart = self.dateFromString(startDate, self.config.multiple.startTime);
              var lastDate = self.dateFromString(endDate, self.config.multiple.endTime);                  
   
              var fullMinuteDiff = lastDate.diff(fullStart, 'minutes');
              var durationHours = Math.floor(fullMinuteDiff / 60) % 24;
              var durationMinutes = fullMinuteDiff % 60;

              if (durationHours) {
                if (self.config.multiple.durationDisplay) {
                  self.config.multiple.durationDisplay += ' ';
                }
                self.config.multiple.durationDisplay += durationHours + ' hours';
              }

              if (!durationMinutes && !self.config.multiple.durationDisplay) {
                self.config.multiple.durationDisplay = durationMinutes + ' minutes';
              }

              if (durationMinutes) {
                if (self.config.multiple.durationDisplay) {
                  self.config.multiple.durationDisplay += ' ';
                }
                self.config.multiple.durationDisplay += durationMinutes + ' minutes';
              }

              self.config.multiple.startDisplay = fullStart.format(self.momentFormat);

              if (!endDate || !self.config.multiple.endTime) {
                return;
              }

              self.config.multiple.endDisplay = lastDate.format(self.momentFormat);
              // Daily instance options
              if (self.config.repeatType === 'daily') {
                var dayMinimum = lastDate.diff(fullStart, 'days');
                if (!self.timeConversions.preliminaryRecurrenceCheck(dayMinimum)) {
                  return;
                }

                // Subtract one day here so the from date will be inclusive
                // We have to clone here since moment objects are mutable
                var recurrence = fullStart.clone().subtract(1, 'days').recur(lastDate).every(1).day();
                if (recurrence && recurrence.all) {
                  self.timeConversions.setIntervals(recurrence.all('L'));
                }
                return;
              }

              // Weekly instance options
              if (self.config.repeatType === 'weekly') {
                if (!self.weeklyOptions.repeatDays || !self.weeklyOptions.repeatDays.length) {
                  return;
                }
                var weekMinimum = lastDate.diff(fullStart, 'weeks');
                if (!self.timeConversions.preliminaryRecurrenceCheck(weekMinimum)) {
                  return;
                }
                // Subtract one day here so the from date will be inclusive
                fullStart.subtract(1, 'days')
                var recurrence = fullStart.recur(lastDate).every(self.weeklyOptions.repeatDays).daysOfWeek();
                if (recurrence && recurrence.all) {
                  self.timeConversions.setIntervals(recurrence.all('L'));
                }
                return;
              }

              // Monthly instance options
              if (self.config.repeatType === 'monthly') {
                var monthMinimum = lastDate.diff(fullStart, 'months');
                if (!self.timeConversions.preliminaryRecurrenceCheck(monthMinimum)) {
                  return;
                }
                if (self.monthlyOptions.type === 'single') {
                  if (!self.monthlyOptions.single) {
                    return;
                  }
                  fullStart.subtract(1, 'days')
                  var recurrence = fullStart.recur(lastDate).every(parseInt(self.monthlyOptions.single)).daysOfMonth();
                  if (recurrence && recurrence.all) {
                    self.timeConversions.setIntervals(recurrence.all('L'));
                  }
                  return;
                }

                if (!self.monthlyOptions.dayType || !self.monthlyOptions.repeatDays || !self.monthlyOptions.repeatDays.length) {
                  return;
                }
                // Subtract one day here so the from date will be inclusive
                var recurrence = fullStart
                  .clone()
                  .subtract(1, 'day')
                  .recur(lastDate)
                  .every(self.monthlyOptions.repeatDays)
                  .daysOfWeek()
                  .every([parseInt(self.monthlyOptions.dayType)])
                  .weeksOfMonthByDay();
                
                if (recurrence && recurrence.all) {
                  self.timeConversions.setIntervals(recurrence.all('L'));
                }
                return;
              }
            },
          };

          self.editing = {
            original: null,
            showSettings: false,
            updateInstance: function () {
              if (!self.config.confirmRequirements()) {
                return;
              }
              self.config.saving = true;

              let body = Object.assign({}, self.config.instanceBody);
              const startBase = self.dateFromString(self.config.single.startDate, self.config.single.startTime);
              const endBase = self.dateFromString(self.config.single.endDate, self.config.single.endTime);

              body.start_date = startBase; 
              body.end_date = endBase;

              const id = body._id;
              body.site = body.site || null;
              delete body.user;
              delete body._id;
              if (self.editing.original.createZoom && !self.config.instanceBody.createZoom) {
                body.zoom_meeting_id = '';
                body.zoom_settings = {};
              }
              if (body.online && body.createZoom && body.zoom_settings) {
                body.zoom_settings.alternative_hosts = self.zoomHosts.stringValue || '';
              }

              if (body.online && self.config.activeMicrosoftTeams) {
                if (!body.microsoft_teams_meeting_id) {
                  body.createMicrosoftTeamsMeeting = true;
                  body.updateMicrosoftTeamsMeeting = false;
                  body.removeMicrosoftTeamsMeeting = false;
                } else {
                  body.updateMicrosoftTeamsMeeting = true;
                  body.createMicrosoftTeamsMeeting = false;
                  body.removeMicrosoftTeamsMeeting = false;
                }
              } 
              if (body.microsoft_teams_meeting_id && !self.config.activeMicrosoftTeams) {
                body.removeMicrosoftTeamsMeeting = true;
                body.createMicrosoftTeamsMeeting = false;
                body.updateMicrosoftTeamsMeeting = false;
              }

              if (body.createMeet) {
                body.meetsCreator = self.user._id;
              }

              WorkshopInstances.update(
                {
                  subresource: id,
                  fields:
                    'start_date,end_date,viewing_timezone,seats,allow_waitlist,waitlist_seats,host,location,online_location_label,online,site,google_calendar_entity,google_calendar_see_attendees,remove_on_google_decline,zoom_meeting_id,zoom_settings,microsoft_teams_meeting_id,microsoft_teams_meeting_settings',
                },
                body
              )
                .$promise.then(function (instance) {
                  $scope.hideShow = false;
                  $scope.datesAdded();
                  Application.messaging.addMessage({ type: 'success', duration: 3, text: 'Date changes saved.' });
                  self.config.saving = false;
                  if ($scope.onChange) {
                    $scope.onChange();
                  }
                })
                .catch(function (error) {
                  if (error.data && error.data.errors) {
                    Application.messaging.renderApiResponseErrorCodes(error.data, {
                      ZOOM_API_CREATE_ERROR: self.translations["errors.workshop.instance.update.ZOOM_API_CREATE_ERROR"],
                      MEETS_API_CREATE_ERROR: self.translations["errors.workshop.instance.update.MEETS_API_CREATE_ERROR"]
                    });
                  } else if (error.data && error.data.message) {
                    Application.messaging.addMessage({ type: 'error', duration: 5, text: error.data.message });
                  } else {
                    Application.messaging.addMessage({ type: 'error', duration: 5, text: 'There was an error saving the changes.' });
                  }
                  self.config.saving = false;
                });
            },
          };

          var watchHold = false;

          var watchTrigger = function (checkTime, changed) {
            if (watchHold) {
              return;
            }

            watchHold = true;

            if (checkTime) {
              if (self.config.dateType === 'single') {
                self.timeConversions.singleCheckTime(changed);
              }
              if (self.config.dateType === 'multiple') {
                self.timeConversions.multipleCheckTime(changed);
              }
            }

            self.timeConversions.setInstances();

            watchHold = false;
          };

          var setWatches = function () {
            $scope.$watch('dateSet.monthlyOptions.single', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger();
            });
            $scope.$watch('dateSet.monthlyOptions.type', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger();
            });
            $scope.$watch('dateSet.monthlyOptions.dayType', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger();
            });
            $scope.$watch('dateSet.config.repeatType', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger();
            });
            $scope.$watch('dateSet.config.multiple.duration', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger(true);
            });
            $scope.$watch('dateSet.config.multiple.startTime', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger(true);
            });
            $scope.$watch('dateSet.config.multiple.endTime', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger(true);
            });
            // ! Leaving commented in case this fix for DEV-10864 goes haywire
            // var oldTz;
            // $scope.$watch('dateSet.config.instanceBody.viewing_timezone', function (newVal, oldVal) {
            //   if (!newVal || newVal === oldVal) {
            //     return;
            //   }
            //   var dateType = self.config.dateType;
            //   watchHold = true;
            //   var previousTz = oldTz || oldVal || newVal;
            //   var previousStart = self.dateFromString(self.config[self.config.dateType].startDate, self.config[self.config.dateType].startTime, previousTz);
            //   var previousEnd = self.dateFromString(self.config[self.config.dateType].endDate, self.config[self.config.dateType].endTime, previousTz);
              
            //   self.init.handleTz(previousStart, previousEnd);
            //   oldTz = newVal;
            //   watchHold = false;
            // });
            $scope.$watch('dateSet.config.single.startTime', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger(true, 'start');
            });
            $scope.$watch('dateSet.config.single.endTime', function (newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              watchTrigger(true, 'end');
            });
          };

          self.init = {
            reset: function (original) {
              watchHold = true;

              if ($scope.editing) {
                self.config.transferEditItems.forEach(function (item) {
                  if (original[item]) {
                    self.config.instanceBody[item] = original[item];
                  }
                });

                if (original.online && original.zoom_meeting_id) {
                  self.config.instanceBody.createZoom = true;
                  self.config.instanceBody.zoomType = original.zoom_settings?.meeting_type || 'meeting';
                  if (original.zoom_settings && original.zoom_settings.alternative_hosts) {
                    self.zoomHosts.parseEdit(original.zoom_settings.alternative_hosts);
                  }
                }

                if (self.config.instanceBody.google_meets && self.config.instanceBody.google_meets.link && self.config.instanceBody.google_meets.link === self.config.instanceBody.online_location) {
                  self.madeWithGoogle = true;
                }

                self.editing.showSettings = false;
                self.editing.original = JSON.parse(JSON.stringify(self.config.instanceBody));
              } else {
                self.config.transferDefaultItems.forEach(function (item) {
                  if (original[item]) {
                    self.config.instanceBody[item] = original[item];
                  }
                });
              }

              if (!self.config.instanceBody.zoom_settings) {
                self.config.instanceBody.zoom_settings = {};
              }

              if (original.start_date && original.end_date) {
                self.init.handleTz(original.start_date, original.end_date);
              }

              watchHold = false;
              setTimeout(function () {
                watchTrigger();
                setWatches();
                $scope.$apply();
              }, 10);
              self.config.loading = false;
            },
            handleTz: function (start, end) {
              if (start !== undefined) {
                var startMoment = moment(start).tz(self.config.instanceBody.viewing_timezone);
                self.config[self.config.dateType].startDate = startMoment.format(self.momentFormat);
                self.config[self.config.dateType].startTime = self.timeConversions.dateFromMoment(startMoment);

              }

              if (end !== undefined) {
                var endMoment = moment(end).tz(self.config.instanceBody.viewing_timezone);
                self.config[self.config.dateType].endDate = endMoment.format(self.momentFormat);
                self.config[self.config.dateType].endTime = self.timeConversions.dateFromMoment(endMoment);
              }
              
            },
            check: function () {
              self.config.loading = true;
              self.config.resetInstanceBody();
              if (!$scope.editing) {
                if ($scope.defaultInstance) {
                  self.config.resetInstance($scope.defaultInstance);
                  return;
                }
                self.init.reset({});
              }

              if ($scope.editing) {
                if ($scope.instance) {
                  self.config.resetInstance($scope.instance);
                  return;
                }
                var instanceWatch = $scope.$watch('instance', function (newVal, oldVal) {
                  if (newVal && newVal !== oldVal) {
                    self.config.resetInstance($scope.instance);
                    instanceWatch();
                  }
                });
              }
            },
          };

          const flags = Application.features.flags();
          if (flags.zoom) {
            ZoomIntegrate.existsWithUser({ subsubresource: window.encodeURIComponent(self.user.email) }).$promise.then(function (results) {
              self.config.zoomAllowed = results.exists || false;
              self.config.zoomUserAllowed = results.user_exists || false;
              self.config.allowWebinar = results.webinars || false;
            });
          }

          self.config.microsoftTeamsAllowed = flags.microsoft_teams_meetings;
          if (self.config.microsoftTeamsAllowed) {
            MicrosoftTeams.checkExists({userId: self.user._id.toString()}).$promise.then(function (results) {
              self.config.microsoftTeamsIntegrated = results.microsoftTeamsExists;
            });
          }

          if (self.config.meetsAllowed) {
            Meets.existsWithUser({}).$promise.then(function (results) {
              self.config.meetsUserEnabled = (results.exists) || false;
            });
          }

          $scope.$watch('hideShow', function (newVal, oldVal) {
            if (newVal && !oldVal) {
              self.init.check();
            }
          });

          self.init.check();
        },
      ],
      controllerAs: 'dateSet',
    };
  },
]);
